export enum EnumSeveridadeApi {
  Informacao = 1,
  Sucesso = 2,
  Erro = 3,
  Alerta = 4
}